export default __webpack_public_path__ + "static/media/gradient-square.263e7e19.png";